/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Cognos Analytics
 * (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define('collaboration/messaging/utils/ImageUtils',[], function () {
	'use strict';

	return {
		base64ToBlob: function base64ToBlob(base64, mime) {
			mime = mime || '';
			var sliceSize = 1024;
			var byteChars = window.atob(base64);
			var len = byteChars.length;
			var byteArrays = [];
			for (var offset = 0; offset < len; offset += sliceSize) {
				var slice = byteChars.slice(offset, offset + sliceSize);
				var byteNumbers = new Array(slice.length);
				for (var i = 0; i < slice.length; i++) {
					byteNumbers[i] = slice.charCodeAt(i);
				}
				var byteArray = new window.Uint8Array(byteNumbers);
				byteArrays.push(byteArray);
			}
			return new Blob(byteArrays, {
				type: mime
			});
		}
	};
});
;

var _temp = function () {
	if (typeof __REACT_HOT_LOADER__ === 'undefined') {
		return;
	}
}();

;

